import { Dispatch, SetStateAction } from 'react';
import { TFunction } from 'react-i18next';

import { noColumnStyle } from '../../../../utils/constants/tables';
import ActionsTableMenu from '../../Components/ActionsTableMenu/ActionsTableMenu';
import { Ports } from './Dialogs/CreateDialogSortingMap/CreateDialogSortingMap.functions';

export type SortingMapsType = {
  id: number;
  sortMachineId: number;
  sortMachineName?: string;
  name: string;
  description: string;
  errorPort: number;
  unmatchedPort: number;
  ports: Ports[];
};

export type SortingMapsPortsType = {
  id?: number;
  logisticsPointId: number;
  port: number;
  pointName?: string;
  logisticsPointTypeId?: number;
  logisticsPointName?: string;
};

export const tableStorageKey = 'sorting_maps_dataTable';

export function getColumnHeadersMap(t: TFunction) {
  return {
    no: t('No.'),
    name: t('Name'),
    sortMachineName: t('Sorting machine name'),
    description: t('Description'),
    errorPort: t('Error port'),
    unmatchedPort: t('Unmatched port'),
  };
}

export function additionalColumnProperties(
  t: TFunction,
  column: keyof ReturnType<typeof getColumnHeadersMap> | 'actions',
  setContextMenuSelection: Dispatch<SetStateAction<any>>,
  setAction: (t: string) => void,
  setCaller: Dispatch<SetStateAction<'context-menu' | 'group-actions'>>,
  readGuard: boolean,
  editGuard: boolean,
  deleteGuard: boolean
) {
  switch (column) {
    case 'no':
      return {
        noColumnStyle,
        style: {
          width: 30,
          maxWidth: 30,
        },
        bodyStyle: {
          width: 30,
          maxWidth: 30,
          display: 'flex',
          textAlign: 'center',
        },
      };

    case 'name':
    case 'sortMachineName':
    case 'description':
      return {
        style: { width: 250 },
        bodyStyle: { width: 250 },
      };

    case 'errorPort':
    case 'unmatchedPort':
      return {
        style: { width: 100 },
        bodyStyle: { width: 100 },
      };

    case 'actions':
      return {
        body: (row: SortingMapsType) => {
          return (
            <ActionsTableMenu
              actions={[
                {
                  label: t('View Details'),
                  icon: 'fas fa-search',
                  disabled: !readGuard,
                  command: () => {
                    setContextMenuSelection(row);
                    setAction('view-details');
                    setCaller('context-menu');
                  },
                },
                {
                  label: t('Edit'),
                  icon: 'fas fa-edit',
                  disabled: !editGuard,
                  command: () => {
                    setContextMenuSelection(row);
                    setAction('edit');
                    setCaller('context-menu');
                  },
                },
                {
                  label: t('Delete'),
                  icon: 'fas fa-times',
                  disabled: !deleteGuard,
                  command: () => {
                    setContextMenuSelection(row);
                    setCaller('context-menu');
                    setAction('delete');
                  },
                },
              ]}
            />
          );
        },
        style: {
          width: 60,
          borderLeft: '1px solid #e9ecef',
          flex: '0 1 auto',
          position: 'sticky',
        },
        bodyStyle: {
          width: 60,
          borderLeft: '1px solid #e9ecef',
          flex: '0 1 auto',
          position: 'sticky',
          justifyContent: 'center',
        },
      };

    default:
      return {};
  }
}
